import React from 'react';
export function HeroSection() {
  return <>
      {/* Banner fino de oferta */}
      <div className="w-full bg-gradient-to-r from-[#e53935] to-[#ef5350] py-1.5 px-4 overflow-hidden" data-id="element-112">
        <div className="animate-scroll-right" data-id="element-113">
          <p className="text-white text-xs md:text-sm font-black tracking-widest whitespace-nowrap uppercase" data-id="element-114">
            💈 Oferta por lanzamiento — 60% de descuento · Acceso inmediato ·
            100% online 💈 Oferta por lanzamiento — 60% de descuento · Acceso
            inmediato · 100% online
          </p>
        </div>
      </div>

      <section className="w-full bg-gradient-to-b from-[#1a1a22] via-[#141418] to-[#111116] py-10 md:py-16 lg:py-20 px-4 relative overflow-hidden" data-id="element-115">
        {/* Glow decorativo de fondo */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#e53935]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-116"></div>

        {/* Logo flotante */}
        <div className="fixed top-4 left-4 z-50" data-id="element-117">
          <img src="https://cdn.magicpatterns.com/uploads/nTBDp8jLQqs428HDhKddZJ/ChatGPT_Image_24_feb_2026,_12_38_15_a.m..png" alt="Barber Pro Academy Logo" className="w-12 h-12 md:w-16 md:h-16 drop-shadow-2xl" data-id="element-118" />
        </div>

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-119">
          <div className="text-center mb-8 md:mb-12" data-id="element-120">
            {/* Pre-headline */}
            <p className="text-xs md:text-sm text-[#ef5350] mb-4 font-black tracking-widest uppercase bg-[#ef5350]/10 inline-block px-4 py-1.5 rounded-full border border-[#ef5350]/20" data-id="element-121">
              FORMACIÓN PROFESIONAL EN BARBERÍA
            </p>

            {/* H1 */}
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black leading-[1.1] text-white mb-5 md:mb-6" data-id="element-122">
              Aprendé barbería desde cero y desarrollá una habilidad que puede
              convertirse en{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ef5350] to-[#ff7043]" data-id="element-123">
                tu propio oficio.
              </span>
            </h1>

            {/* Subtítulo */}
            <p className="text-base md:text-xl text-gray-300 leading-relaxed max-w-xl mx-auto mb-8 md:mb-10" data-id="element-124">
              Una formación online con clases en video paso a paso, técnica
              profesional y un manual completo para dominar la barbería desde
              cero.
            </p>

            {/* Bullets arriba del botón */}
            <div className="grid grid-cols-2 gap-3 max-w-lg mx-auto text-left mb-8 md:mb-10" data-id="element-125">
              {[{
              text: 'Clases en video',
              icon: '🎥'
            }, {
              text: 'Método profesional',
              icon: '💈'
            }, {
              text: 'Acceso inmediato',
              icon: '⚡'
            }, {
              text: 'Manual incluido',
              icon: '📘'
            }].map(bullet => <div key={bullet.text} className="flex items-center gap-2 text-gray-200 bg-white/5 backdrop-blur-sm p-3 rounded-lg border border-white/10 shadow-sm" data-id="element-126">
                  <span className="text-lg flex-shrink-0" data-id="element-127">{bullet.icon}</span>
                  <span className="text-sm md:text-base font-semibold" data-id="element-128">
                    {bullet.text}
                  </span>
                </div>)}
            </div>

            {/* CTA principal */}
            <div className="flex flex-col items-center gap-3 mb-10 md:mb-12" data-id="element-129">
              <a href="#pricing" className="cta-primary text-white font-black text-base md:text-xl px-10 md:px-14 py-4 md:py-5 rounded-xl inline-block text-center" aria-label="Acceder a la formación" data-id="element-130">
                👉 ACCEDER A LA FORMACIÓN
              </a>
            </div>

            {/* Video principal */}
            <div className="flex justify-center mb-6 md:mb-8" data-id="element-131">
              <div className="relative w-64 md:w-80 lg:w-96 aspect-[4/5] rounded-2xl overflow-hidden shadow-[0_0_50px_rgba(229,57,53,0.12)] border-2 border-white/10" data-id="element-132">
                <video src="https://cdn.magicpatterns.com/uploads/7fxPLbNf5mBaahruzQnSNU/PinDown.io_@bonshair_1772370785.mp4#t=7" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-133" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#111116] via-transparent to-transparent opacity-50 pointer-events-none" data-id="element-134"></div>
              </div>
            </div>

            {/* Mensaje emocional abajo del video */}
            <div className="flex justify-center mb-10 md:mb-14" data-id="element-135">
              <p className="text-gray-300 text-sm md:text-base font-semibold bg-white/5 backdrop-blur-sm border border-white/10 px-5 py-3 rounded-xl shadow-md max-w-md" data-id="element-136">
                ✨ Invertí en aprender un oficio que puede servirte toda la
                vida.
              </p>
            </div>

            {/* Bloque: Qué vas a aprender */}
            <div className="max-w-2xl mx-auto" data-id="element-137">
              <h2 className="text-2xl md:text-3xl font-black text-white mb-6 md:mb-8" data-id="element-138">
                Todo lo que vas a aprender en esta formación
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-left mb-6 md:mb-8" data-id="element-139">
                {[{
                icon: '✂️',
                text: 'Fades y degradados profesionales'
              }, {
                icon: '🔧',
                text: 'Uso correcto de máquinas de barbería'
              }, {
                icon: '💈',
                text: 'Perfilado de barba y contornos'
              }, {
                icon: '🎯',
                text: 'Técnica profesional paso a paso'
              }, {
                icon: '📐',
                text: 'Cómo estructurar un corte correctamente'
              }, {
                icon: '🪒',
                text: 'Cómo mejorar la precisión en cada corte'
              }, {
                icon: '💼',
                text: 'Cómo trabajar la barbería como un oficio'
              }, {
                icon: '📈',
                text: 'Aprender a manejar tu barbería como negocio'
              }].map(item => <div key={item.text} className="flex items-start gap-3 bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-3 md:p-4" data-id="element-140">
                    <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-141">
                      {item.icon}
                    </span>
                    <span className="text-sm md:text-base text-gray-200 font-semibold leading-snug" data-id="element-142">
                      {item.text}
                    </span>
                  </div>)}
              </div>
              <p className="text-gray-400 text-sm md:text-base font-semibold leading-relaxed max-w-lg mx-auto" data-id="element-143">
                Todo explicado dentro de un método claro para aprender barbería
                de forma profesional.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>;
}